import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask2300To2399Service {

  constructor() { }
}
